export default{
  // Not empty & Maximum length 200 letters
  required: {
		test: function(val){
			if(typeof val == 'undefined' || val == null || val === ''){
				return false;
      }
      if(val.length > 200){
        return false;
      }
			return true;
		},
		message: localStorage.getItem('Language') == '1' ? 'Not empty' : (localStorage.getItem('Language') == '2' ? '必填' : '必填')
  },
  // Not empty & 4 digits (alphanumeric)
  alphanumeric4: {
    test: function(val) {
			const reg = /^[A-Za-z0-9]{4}$/;
			if(!reg.test(val)){
				return false;
			}
			return true;
    },
    message: localStorage.getItem('Language') == '1' ? 'Not empty & 4 digits (alphanumeric)' : (localStorage.getItem('Language') == '2' ? '填入4個數字或字母' : '填入4个数字或字母')
  },
  address: {
		test: function(val){
			if(typeof val == 'undefined' || val == null || val === ''){
				return false;
      }
      if(val.length > 400){
        return false;
      }
			return true;
		},
		message: localStorage.getItem('Language') == '1' ? 'Not empty' : (localStorage.getItem('Language') == '2' ? '必填' : '必填')
  },
  // email
  email: {
    test: function(val) {
			const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
			if(!reg.test(val)){
				return false;
			}
			return true;
    },
    message: localStorage.getItem('Language') == '1' ? 'email Error' : (localStorage.getItem('Language') == '2' ? '請填入正確的郵箱' : '请填入正确的邮箱')
  },
	/*phoneAndMobile 电话号码（手机）*/
	phoneAndMobile:{
		test:function(val){
			var reg = /(^(\d{3,4}-)?\d{7,8})$|(1[0-9]{10})/;
			if(!reg.test(val)){
				return false;
			}
			return true;
		},
		message: localStorage.getItem('Language') == '1' ? 'phone Error' : (localStorage.getItem('Language') == '2' ? '請填入正確的電話號碼' : '请填入正确的电话号码')
	},
	//必选
	selected:{
		test:function(val){
			if(typeof val == 'undefined' || val == null || val === ''){
				return false;
			}
			return true;
		},
		message:"必选"
  },

	/*正整数*/
	positiveInteger:{
		test:function(val){
			const reg = /^[1-9]\d*$/;
			if(!reg.test(val)){
				return false;
			}
			return true;
		},
		message:"请输入大于0的整数"
	},
	/*非负数*/
	nonnegative:{
		test:function(val){
			var reg = /^\d+(\.{0,1}\d+){0,1}$/;
			if(!reg.test(val)){
				return false;
			}
			return true;
		},
		message:"请输入大于0或者等于0的数"
	},
}	


// WEBPACK FOOTER //
// ./src/util/verifyRules.js